import React, { PureComponent } from 'react';
import { Empty } from 'antd';
import './index.css';

class RechargeFinish extends PureComponent {
  render() {
    return (
      <Empty
        imageStyle={{
          height: 100,
        }}
        description={
          <div className="recharge-finish-info">
            <div>支付已完成，您可以关闭此页面，在之前的页面点击"完成支付"。</div>
            <div>强烈建议您<span className="strong">进行完网银交易复核之后</span>，再点击"完成支付"</div>
          </div>
        }
      />
    );
  }
}

export default RechargeFinish;



// WEBPACK FOOTER //
// ./src/pages/agent/AccountCenter/RechargeFinish/index.js